import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ca } from '@cian/analytics';
import { getCianAnalyticsObjectPage } from '../../utils/tracking';

/**
 * СОБЫТИЯ ФЛОУ АВТОРИЗАЦИИ ПО ТЕЛЕФОНУ
 */

/**
 * Клик по ссылке отправить еще раз
 */
export function trackPhoneAuthResendValidationCode(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'phone_send_again'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Клик на "Мне не позвонили" при авторизации/регистрации через последние 4 цифры телефона
 */
export function trackPhoneAuthResendCodeClick(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click_resend_code',
    label: 'last_phone_numbers'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Введен неверный код подтверждения, полученный по СМС
 */
export function trackPhoneAuthSmsValidationFail(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'phone_simple'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Введен неверный код подтверждения, полученный по телефонному звонку
 */
export function trackPhoneAuthCallValidationFail(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'last_phone_numbers'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Введен неверный код, превышено кол-во попыток
 */
export function trackPhoneAuthExhausted(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'phone_fatal'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Клик по кнопке продолжить, после ввода телефона
 */
export function trackPhoneAuthResumeButtonClick(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'phone_continue'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Клик по ссылке нужна помощь
 */
export function trackPhoneAuthNeedHelp(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'phone_cant_confirm'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Показ экрана с запросом на ввод 4 последних цифр номера телефона
 */
export function trackPhoneAuthCallShow(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Open',
    label: 'last_phone_numbers'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Клик на "Ввести заново" при авторизации/регистрации через звонок
 * Кнопка появляется в результате некорректной отправки кода
 */
export function trackPhoneAuthCallReEnterButtonClick(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click_re_enter_phone_code',
    label: 'last_phone_numbers'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}